'use client';
import { useEffect } from 'react';

import Link from 'next/link';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ErrorGif from '../../public/images/vms/error-gif.gif';

interface Props {
    error: Error;
    reset: () => void;
}

export default function GlobalError({ error, reset }: Props) {
    useEffect(() => {
        console.error('[GlobalError]', error);
    }, [error]);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default',
                p: 2,
            }}
        >
            <Card sx={{ maxWidth: 400, textAlign: 'center' }}>
                <CardContent>
                    <Typography variant='h1' component='div'>
                        <img
                            src={ErrorGif.src}
                            width={350}
                            height={250}
                            style={{
                                objectFit: 'cover',
                                objectPosition: 'center',
                            }}
                        />
                    </Typography>
                    <Typography variant='h5'>
                        Oops! Đã có sự cố xảy ra.
                    </Typography>
                    <Typography
                        variant='body2'
                        color='text.secondary'
                        sx={{ mb: 3 }}
                    >
                        Chúng tôi đang cố gắng khôi phục. Bạn có thể thử lại
                        hoặc quay về trang chủ.
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            justifyContent: 'center',
                        }}
                    >
                        <Button variant='contained' onClick={() => reset()}>
                            Thử lại
                        </Button>
                        <Link href='/home' passHref>
                            <Button variant='outlined'>Về trang chủ</Button>
                        </Link>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}
